module.exports = require("./sl.d.ts");